export { default } from './set-language-cookie'
